import { FirebaseDocRefType } from 'firebase/index'
import { CheckoutStatusType, CheckoutType } from 'types/checkout'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { fetchOrdersAction, setCheckoutUnsubscribesAction } from 'reducks/checkout/actions'
import { dateToString } from 'lib/helper'
import { CheckoutItemType } from 'types/checkoutItem'
import {
  fetchBreadRefsByManufacturerRef,
  fetchCheckoutItemsByRef,
  mergeListeningCheckoutWithItems,
} from 'reducks/checkout/operations'
import { StockUnionType } from 'types/stock'

const fetchOrdersInPeriod = (
  startDate: Date,
  endDate: Date,
  accountingType: 'order' | 'deliver',
  storeRef: FirebaseDocRefType,
  status: CheckoutStatusType[],
  types: StockUnionType[]
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // unsubscribeがセットされている状態（リスナーがONの状態）であれば処理しない
    if (getState().checkout.is_set_unsubscribe) return

    dispatch(showLoadingAction())
    const manufacturerRef: FirebaseDocRefType = getState().auth.manufacturer_ref
    let breadRefs: FirebaseDocRefType[] = []
    const isSacriStationMode = typeof manufacturerRef !== 'undefined'

    // 販売元店舗がsacri stationを表示する場合、自店舗の決済のみに絞り込む
    if (isSacriStationMode) {
      breadRefs = await fetchBreadRefsByManufacturerRef(storeRef, manufacturerRef)
      // sacri stationに出品していない場合
      if (breadRefs.length === 0) {
        dispatch(fetchOrdersAction([]))
        dispatch(hideLoadingAction())
        return
      }
    }
    // ステータスと注文タイプに応じてクエリを作成する
    let query = storeRef.collection('store_checkouts').where('status', 'in', status)
    // 計上設定が「注文が入った日」か「お客さまの受取日」のいずれかでクエリを切り替える
    if (accountingType === 'order') {
      query = query.orderBy('updated_at', 'asc').startAt(startDate).endAt(endDate)
    } else if (accountingType === 'deliver') {
      query = query.orderBy('date', 'asc').startAt(dateToString(startDate)).endAt(dateToString(endDate))
    }

    const unsubscribe = await query.onSnapshot(async (snapshots) => {
      const itemPromises: Promise<CheckoutItemType[]>[] = []
      // データの追加のみ監視する
      const changes = snapshots.docChanges().filter((change) => {
        const data = change.doc.data() as CheckoutType
        return change.type === 'added' && types.includes(data.type)
      })
      changes.forEach((change) => {
        itemPromises.push(fetchCheckoutItemsByRef(change.doc.ref, breadRefs))
      })
      const result = await Promise.all(itemPromises).catch((error) => {
        throw new Error(`注文商品の一括取得に失敗: ${error}`)
      })
      const items = result.reduce((prev, _items) => [...prev, ..._items], [])
      const currentOrders = getState().checkout.orders
      const sortKey = accountingType === 'order' ? 'updated_at' : 'date'
      mergeListeningCheckoutWithItems(changes, items, currentOrders, dispatch, sortKey, 'asc')
    })

    dispatch(setCheckoutUnsubscribesAction([unsubscribe]))
    dispatch(hideLoadingAction())
  }
}

export default fetchOrdersInPeriod
